/**
 * Inferred field type based on sample values.
 * Determines which operators are compatible.
 * More types will be added in the future.
 */
export type FieldType = 'BOOLEAN' | 'STRING';

/**
 * Infer the field type from its sample values.
 * - BOOLEAN: every sample value is "true" or "false" (case-insensitive)
 * - STRING: everything else (default)
 */
export function inferFieldType(sampleValues: Array<{ value: string }>): FieldType {
  if (sampleValues.length === 0) {
    return 'STRING';
  }
  const boolSet = new Set(['true', 'false']);
  return sampleValues.every(({ value }) => boolSet.has(value.toLowerCase())) ? 'BOOLEAN' : 'STRING';
}
